/*@ngInject*/
const UiFormTemplateRepository = function (baseRepository, databaseDownloadSectionName, temporaryLoginTokenRepository) {

    angular.extend(this, baseRepository);

    this.getUiFormTemplatesByFilterUri = function (filterUri, requestParams) {
        let url = '/rest/UIFormTemplate/filter',
            config = {
                params: {
                    filterUri: filterUri,
                    sortBy: requestParams.key,
                    sortDirection: requestParams.sortType,
                    startIndex: requestParams.startIndex,
                    numberOfRows: requestParams.pageSize
                }
            };

        return this.get(url, config);
    };

    this.getUIFormTemplatesByMatchingName = function (matchingName) {
        let url = '/rest/UIFormTemplate/uniqueNames/',
            config = {
                params: {
                    matchingName: matchingName
                }
            };

        return this.get(url, config);
    };

    this.getFieldOptions = function (formTemplateUniqueName, fieldName) {
        let url = '/rest/UIFormTemplate/fieldOptions',
            config = {
                params: {
                    formTemplateUniqueName: formTemplateUniqueName,
                    fieldName: fieldName
                }
            };

        return this.get(url, config);
    };

    this.getUiFormTemplateById = function (uiFormTemplateId) {
        let url = '/rest/UIFormTemplate/' + uiFormTemplateId,
            config = {};

        return this.get(url, config);
    };

    this.getFieldRulesByUIFormTemplateId = function (uiFormTemplateId) {
        let url = '/rest/UIFormTemplate/' + uiFormTemplateId + '/fieldRules',
            config = {};

        return this.get(url, config);
    };

    this.createFormTemplate = function (uiFormTemplate) {
        let url = '/rest/UIFormTemplate';
        return this.post(url, uiFormTemplate);
    };

    this.updateFormTemplate = function (uiFormTemplate, id) {
        let url = '/rest/UIFormTemplate/' + id;
        return this.post(url, uiFormTemplate);
    };

    this.findReferenceCountByFieldTemplateId = function (fieldTemplateId) {
        let url = '/rest/UIFormTemplate/findReferenceCountByFieldTemplateId',
            config = {
                params: {
                    fieldTemplateId: fieldTemplateId
                }
            };

        return this.get(url, config);
    };

    this.deleteUIFormTemplates = function (uiFormTemplateIds) {
        let url = '/rest/UIFormTemplate',
            config = {
                params: {
                    uiFormTemplateIds: uiFormTemplateIds
                }
            };

        return this.delete(url, config);
    };

    this.markFormTemplatesInProduction = function (uiFormTemplateIds) {
        let url = '/rest/UIFormTemplate/markInProduction',
            config = {
                params: {
                    uiFormTemplateIds: uiFormTemplateIds
                }
            };

        return this.post(url, {}, config);
    };

    this.markFormTemplatesInProductionByFilterUri = function (filterUri, excludedUiFormTemplateIds) {
        let url = '/rest/UIFormTemplate/markInProduction',
            config = {
                params: {
                    filterUri: filterUri,
                    excludedFormTemplateIds: excludedUiFormTemplateIds
                }
            };

        return this.post(url, {}, config);
    };

    this.importFormTemplates = function (file) {
        let url = '/databaseUpload/DatabaseUploadServlet',
            formData = new FormData(),
            config = {
                transformRequest: angular.identity,
                params: {
                    mode: 'unmarshal',
                    operation: 'INSERT',
                    sectionName: databaseDownloadSectionName.FORM_TEMPLATES
                },
                // When you assign undefined, the content type defaults to multipart/form-data
                headers: {
                    'Content-Type': undefined
                }
            };
        formData.append('file', file);

        return temporaryLoginTokenRepository.getSingleUseToken().then((token) => {
            config.params.t = token;
            return this.post(url, formData, config);
        });
    };

        this.exportFormTemplates = function (formTemplateIds) {
            let url = '/database',
                config = {
                    params: {
                        mode: 'marshal',
                        sectionName: databaseDownloadSectionName.FORM_TEMPLATES,
                        entityIdentifiers: _.join(formTemplateIds)
                    }
                };

        return temporaryLoginTokenRepository.getSingleUseToken().then((token) => {
            config.params.t = token;
            return this.get(url, config);
        });
    };

        this.exportFormTemplatesByFilterUri = function (filterUri, excludedFormTemplateIds) {
            let url = '/databaseWithFilter',
                config = {
                    params: {
                        mode: 'marshal',
                        sectionName: databaseDownloadSectionName.FORM_TEMPLATES,
                        filterUri: filterUri,
                        excludedEntityIdentifiers: _.join(excludedFormTemplateIds)
                    }
                };

        return temporaryLoginTokenRepository.getSingleUseToken().then((token) => {
            config.params.t = token;
            return this.get(url, config);
        });
    };

    this.reloadFormRules = function (validate) {
        let url = '/rest/UIFormTemplate/reloadFormRules',
            config = {
                params: {
                    validate: validate
                }
            };

        return this.post(url, {}, config);
    };

    this.reloadFieldRules = function (validate) {
        let url = '/rest/UIFormTemplate/reloadFieldRules',
            config = {
                params: {
                    validate: validate
                }
            };

        return this.post(url, {}, config);
    };

    this.getByFormTemplateIds = function (formTemplateIds) {
        let url = '/rest/UIFormTemplate/Array?formTemplateId=' + formTemplateIds;

        return this.get(url);
    };

    this.getRepeatingFormTemplateUniqueNames = function () {
        let url = '/rest/UIFormTemplate/repeatingFormTemplateUniqueNames';
        return this.get(url);
    };

    this.getJsBuilderOptions = function (uiFormTemplateId) {
        let url = '/rest/UIFormTemplate/' + uiFormTemplateId + '/jsOptions';
        return this.get(url);
    };

    this.validateRegExp = function (regExp, value) {
        let url = '/rest/UIFormTemplate/validateRegEx',
            body = 'regExp=' + encodeURIComponent(regExp) + '&value=' + encodeURIComponent(value),
            config = {
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            };
        return this.post(url, body, config);
    };

    this.formTemplateBackup = function() {
        let url = '/database/DatabaseDownloadServlet',
            config = {
                params: {
                    sectionName: databaseDownloadSectionName.FORM_TEMPLATES
                }
            };

        return temporaryLoginTokenRepository.getSingleUseToken().then((token) => {
            config.params.t = token;
            return this.get(url, config);
        });
    };

    this.findUIFieldByUIFormTemplateUniqueNameAndFieldName = function (uiFormTemplateUniqueName, fieldName) {
        let url = '/rest/UIFormTemplate/UIField',
            config = {
                params: {
                    uiFormTemplateUniqueName: uiFormTemplateUniqueName,
                    fieldName: fieldName
                }
            };

        return this.get(url, config);
    };

};
angular.module('umCore')
    .service('uiFormTemplateRepository', UiFormTemplateRepository);
